import './vendors/h5bp';

function contactGoogleMaps() {
  
  // Ubicación LAT
  var lugar = new google.maps.LatLng(-31.738772, -60.530758);

  // Estilos
  var estilos = [ { "featureType": "landscape", "stylers": [ { "color": "#ffffff" } ] },{ "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#0c8ca4" } ] },{ "featureType": "water", "stylers": [ { "color": "#015466" } ] } ];

  // Opciones del mapa
  var mapOptions = {
    center: lugar,
    zoom: 15,
    styles: estilos,
    scrollwheel: false
  };

  // Crear mapa
  var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

  // Marcador
  var marker = new google.maps.Marker({
    position: lugar,
    icon: "../assets/media/location-icon.png",
    map: map,//lo asocio al mapa
    optimized: false
  });

  var infoWindow = new google.maps.InfoWindow({
      content: "<p style='text-align:center'>9 de Julio 480 <br> C.P. E3100AEJ <br> Paraná | Entre Ríos</p>"
  });

  google.maps.event.addListener(marker, 'click', function () {
      infoWindow.open(map, marker);
  });

}

function goOffices() {
  var markers = [
      ['<b>Casa Central Paraná</b><p>9 de Julio 480 - Paraná <br>0343-4233565 y líneas rotativas <br><a href="mailto:fucofacentral@fucofa.com">fucofacentral@fucofa.com</a></p>', -31.738772, -60.530758],
      ['<b>Colón</b><p>Hector D´Elia 1257 - Villa Elisa  <br>03447-480559  <br><a href="mailto:colon@fucofa.com">colon@fucofa.com</a></p>', -32.165274, -58.400210],
      ['<b>Concordia</b><p>1º de Mayo 215<br>0345-4218877<br><a href="mailto:concordia@fucofa.com">concordia@fucofa.com</a></p>', -31.398341, -58.014381],
      ['<b>Diamante</b><p>San Martin 449<br>0343-4981037<br><a href="mailto:diamante@fucofa.com">diamante@fucofa.com</a></p>', -32.067576, -60.642321],
      ['<b>Federación</b><p>Urquiza 1070 <br>03456-420142<br><a href="mailto:federacion@fucofa.com">federacion@fucofa.com</a></p>', -30.994617, -57.918412],
      ['<b>Federal</b><p>Donovan y Anderson <br> 03454-421191<br><a href="mailto:federal@fucofa.com">federal@fucofa.com</a></p>', -30.952323, -58.781092],
      ['<b>Feliciano</b><p>Belgrano 363 <br> 03458-420030<br><a href="mailto:feliciano@fucofa.com">feliciano@fucofa.com</a></p>', -30.385737, -58.750953],
      ['<b>Gualeguay</b><p>25 de Mayo 630 <br> 03444-423405<br><a href="mailto:gualeguay@fucofa.com">gualeguay@fucofa.com</a></p>', -33.137788, -59.315147],
      ['<b>Gualeguaychu</b><p>Urquiza 881 <br> 03446-433880<br><a href="mailto:gualeguaychu@fucofa.com">gualeguaychu@fucofa.com</a></p>', -33.008943, -58.516602],
      ['<b>Islas</b><p> Arroyo la Tinta s/n <br> 03446-495009 <br><a href="mailto:islas@fucofa.com">islas@fucofa.com</a></p>', -33.722756, -58.582948],
      ['<b>La Paz</b><p>Sarmiento 1279 <br> 03437-422279<br><a href="mailto:lapaz@fucofa.com">lapaz@fucofa.com</a></p>', -30.745984, -59.642028],
      ['<b>Nogoyá</b><p>9 de Julio 963 <br> 03435-421138<br><a href="mailto:nogoya@fucofa.com">nogoya@fucofa.com</a></p>', -32.397440, -59.789454],
      ['<b>San Salvador</b><p>Arroyo Grande y Malarin <br>0345-4910826<br><a href="mailto:sansalvador@fucofa.com">sansalvador@fucofa.com</a></p>', -31.624284, -58.499941],
      ['<b>Tala</b><p>Centenario 27 <br> 03445-421711 <br><a href="mailto:tala@fucofa.com">tala@fucofa.com</a></p>', -32.301351, -59.141264],
      ['<b>Uruguay</b><p>Eva Perón 134 <br>03442-423303 <br><a href="mailto:uruguay@fucofa.com">uruguay@fucofa.com</a></p>', -32.482613, -58.231548],
      ['<b>Victoria</b><p>Intendente Camoirano 138 <br>03435-422586<br><a href="mailto:victoria@fucofa.com">victoria@fucofa.com</a></p>', -32.621627, -60.153004],
      ['<b>Villaguay</b><p>25 de Mayo 218 <br> 03455-421124 <br><a href="mailto:villaguay@fucofa.com">villaguay@fucofa.com</a></p>', -31.869009, -59.029411]
  ];
  var latlng = new google.maps.LatLng(-32.207784, -59.444093);
  var mapOptions = {
    zoom: 8,
    center: latlng,
    mapTypeControl: false,
    scaleControl: false,
    panControl: false,
    rotateControl: false,
    zoomControl: false,
    streetViewControl: false,
    styles: [ { "featureType": "landscape", "stylers": [ { "color": "#ffffff" } ] },{ "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#0c8ca4" } ] },{ "featureType": "water", "stylers": [ { "color": "#015466" } ] } ]
  };
  var map = new google.maps.Map(document.getElementById('offices-canvas'), mapOptions);
  var infowindow = new google.maps.InfoWindow();
  var marker;
  var i;
  for (i = 0; i < markers.length; i++) {
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(markers[i][1], markers[i][2]),
      map: map,
      icon: '../assets/media/location-icon.png'
    });
    google.maps.event.addListener(marker, 'click', (function (marker, i) {
      return function () {
        infowindow.setContent(markers[i][0]);
        infowindow.open(map, marker);
      };
    })(marker, i));
  }
}

/* 
 * Envío del formulario de contacto
 *
 * - Ejecucion en: $(document).ready()
 */

function contactFormGo(){

  $("#contact-submit").on('click', function(e){//formulario de contacto
    e.preventDefault();

    var okflag=true;
    $('input,textarea').filter('[required]:visible').each(function(i, requiredField){
      if($(requiredField).val()==''){
        if(okflag==true)$('#msg-all').fadeIn().delay(5000).fadeOut();
        okflag=false; 
        $(requiredField).addClass("contact-error");
      }
      else $(requiredField).removeClass("contact-error");
    });

    if(okflag==true)
      $('#msg').addClass("backGload").fadeIn().load('contacto.php', {
        nombre: $('#contact-name').val(),
        telefono: $('#contact-tel').val(),
        telefono2: $('#contact-tel2').val(),
        email: $('#contact-email').val(),        
        mensaje: $('#contact-message').val()
      }, function(){
        $('input, textarea').val("");
        $('#msg').removeClass("backGload");
      });

  });

}


/* 
 * Ejecuto funciones de materialize
 *
 * - Ejecucion en: $(document).ready()
 */
function goMaterialize() {
  $('.slider').slider({height:500});
  $('.slider2').slider({height:400});
  $(".button-collapse").sideNav();
}


/* 
 * Ejecuto funciones de materialize
 *
 * - Ejecucion en: $(document).ready()
 */
 function goSliders() {

  $(".img-slider").slick({
    arrows: true,
    dots: true,
    autoplay: true
  });

  $(".latest-news").slick({
    arrows: false,
    dots: true,
    autoplay: true
  });

}

/*
 * 
 * Ejecuto el llamado de todas las funciones Nac y Pop
 *
 */
$(document).ready(function(){

  // goSliders();
  goMaterialize();

  if($("#map-canvas").length){
    contactFormGo();
    contactGoogleMaps();
  }

  if($("#offices-canvas").length){
    goOffices();
  }


});